import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { ErrorService } from '../services/error.service';
import { ServicosGeraisService } from '../services/servicos-gerais.service';
import { ModalConsultaRegistroComponent } from '../shared/modal/modal-consulta-registro/modal-consulta-registro.component';
import { ModalInformativoJucespComponent } from '../shared/modal/modal-informativo-jucesp/modal-informativo-jucesp.component';
import { ModalLogoutComponent } from '../shared/modal/modal-logout/modal-logout.component';



@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.scss']
})
export class RegistroComponent implements OnInit {
  loginAuth: any;
  localExibicao: any;
  tipoPortal: any;
  dados: any

  constructor(
    private modalService: NgbModal,
    private service: ServicosGeraisService,
    private errorService: ErrorService,
  ) { }

  ngOnInit() {

    this.loadComunicado();

    this.loginAuth = sessionStorage.getItem('loginAuth');

    if (!$('.li-seta').hasClass('ativo')) { //FECHA O SIDE
      $('.li-seta').removeClass('ativo');
      $('.content-inner').animate({ paddingLeft: '6.8rem' });
      $('.navbar-minimal.open').css('width', '80px');
      $('.fa-angle-double-left').addClass('fa-angle-double-right');
      $('.fa-angle-double-left').removeClass('fa-angle-double-left');
      $('li a span').addClass('desc');
      $('li a').removeClass('text-right');
      $('li a').addClass('text-center');
      $('li a span').css('margin', '-20px 0 0 35px');
      $('.nomeExpandir').html(' Expandir Menu ');
    } else { //ABRE O SIDE
      $('.li-seta').addClass('ativo');
      $('.content-inner').animate({ paddingLeft: '18rem' });
      $('.navbar-minimal.open').css('width', '260px');
      $('.fa-angle-double-right').addClass('fa-angle-double-left');
      $('.fa-angle-double-right').removeClass('fa-angle-double-right');
      $('li a span').removeClass('desc');
      $('li a').removeClass('text-center');
      $('li a').addClass('text-right');
      $('li a span').css('margin', '10px');
      $('li a i').css('width', '20px');
      $('.nomeExpandir').html(' Recolher Menu ');
    }

  }

  loadComunicado() {
    this.localExibicao = "REGISTRO";
    this.tipoPortal = "INTEGRADOR"
    this.service.getComunicado(this.localExibicao,this.tipoPortal)
    .then((res) => {
      if(res != ""){
        this.dados = JSON.parse(res);
        if (this.dados.statusComunicado == 'ATIVO') {
          this.openModalComunicado(this.dados);
        }
      }
    }).catch((erro) => {
      this.errorService.error(erro);
    });
  }

  openModalComunicado(dados: any) {
    const modal = this.modalService.open(ModalInformativoJucespComponent, {
      size: 'lg',
      centered: true,
      keyboard: false,
      backdrop: 'static'
    });
    modal.componentInstance.dados = this.dados;
  }  

  openModalConsultaRegistro() {
    this.modalService.open(ModalConsultaRegistroComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  openModalLogout() {
    this.modalService.open(ModalLogoutComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  linkCartorio(){
    if(environment.production){
      window.location.href = environment.linkCartorio
    } else {
      window.location.href = environment.linkCartorio + this.loginAuth;
    }
  }

  linkOab(){
    window.open(environment.linkOab, '_blank');
  }

}
